/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MiscellaneousSpec } from './miscellaneousSpec';
import { DeploymentsCapabilitySpec } from './deploymentsCapabilitySpec';
import { NotificationCapabilitySpec } from './notificationCapabilitySpec';
import { RansomwareCapabilitySpec } from './ransomwareCapabilitySpec';
import { OrgCapabilitiesCostManagement } from './orgCapabilitiesCostManagement';
import { ResourceOrgCapabilitySpec } from './resourceOrgCapabilitySpec';
import { OrgCapabilitiesRollout } from './orgCapabilitiesRollout';
import { AccessCapabilitySpec } from './accessCapabilitySpec';
import { CommerceCapabilitySpec } from './commerceCapabilitySpec';
import { OrgCapabilitiesExternalApproval } from './orgCapabilitiesExternalApproval';


export interface CapabilitiesSpec { 
    commerce?: CommerceCapabilitySpec;
    notification?: NotificationCapabilitySpec;
    deployments?: DeploymentsCapabilitySpec;
    access?: AccessCapabilitySpec;
    miscellaneous?: MiscellaneousSpec;
    ransomware_recovery?: RansomwareCapabilitySpec;
    resource?: ResourceOrgCapabilitySpec;
    fleet_management?: OrgCapabilitiesRollout;
    cost_mgmt?: OrgCapabilitiesCostManagement;
    external_approval?: OrgCapabilitiesExternalApproval;
}

